import Vue from 'vue'
import Router from 'vue-router'
// 首页
import Index from '../pages/Index.vue'
// 大会概况
import Survey from '../pages/Survey.vue'
// 组织机构
import Organized from '../pages/Organized.vue'
// 特邀嘉宾
import SpecialGuest from '../pages/SpecialGuest.vue'
// 大会议题
import Agenda from '../pages/Agenda.vue'
// 新闻中心
import NewsCenter from '../pages/NewsCenter.vue'
// 新闻中心详情
import NewsDetails from '../pages/NewDetails.vue'
// 大会指南
import Guide from '../pages/Guide.vue'
// 我要参展
import Exhibition from '../pages/Exhibition.vue'
// 现场花絮
import LiveHighlights from '../pages/LiveHighlights.vue'
// 现场花絮详情
import LiveDetails from '../pages/LiveDetails.vue'
// 主题演讲
import KeynoteSpeech from '../pages/KeynoteSpeech.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/index',
      name: 'Index',
      component: Index,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/survey',
      name: 'Survey',
      component: Survey,
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/organized',
      name: 'Organized',
      component: Organized,
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/specialGuest',
      name: 'SpecialGuest',
      component: SpecialGuest,
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/agenda',
      name: 'Agenda',
      component: Agenda,
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/newsCenter',
      name: 'NewsCenter',
      component: NewsCenter,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/newsDetails',
      name: 'NewsDetails',
      component: NewsDetails,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/guide',
      name: 'Guide',
      component: Guide,
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/exhibition',
      name: 'Exhibition',
      component: Exhibition,
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/liveHighlights',
      name: 'LiveHighlights',
      component: LiveHighlights,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/liveDetails',
      name: 'LiveDetails',
      component: LiveDetails,
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/keynoteSpeech',
      name: 'KeynoteSpeech',
      component: KeynoteSpeech,
      meta: {
        keepAlive: true
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js